import { Injectable } from '@angular/core';
import { EntityStore } from '@datorama/akita';
import { PaginationParams } from './api-entity.service';

export function createInitialState<T>(): T {
  return null;
}

@Injectable({ providedIn: 'root' })
export class ApiEntityStore<S> extends EntityStore<S> {
  pagination: PaginationParams;

  constructor() {
    super(createInitialState());
  }
}
